import { readFile, stat } from 'node:fs/promises';
import { execGitFile } from '../../git-exec.js';

/** Cap full-file snapshot sent with each change (Session DO / WS payload). */
export const MAX_FULL_FILE_TEXT_BYTES = 512 * 1024;

export async function readWorkspaceFileAsUtf8(absPath: string): Promise<string | undefined> {
  try {
    const st = await stat(absPath);
    if (!st.isFile() || st.size > MAX_FULL_FILE_TEXT_BYTES) return undefined;
    return await readFile(absPath, 'utf8');
  } catch {
    return undefined;
  }
}

export async function readGitBlobAsUtf8(repoPath: string, rev: string, rel: string): Promise<string | undefined> {
  try {
    const { stdout } = await execGitFile(['show', `${rev}:${rel}`], { cwd: repoPath });
    return stdout.length > MAX_FULL_FILE_TEXT_BYTES ? undefined : stdout;
  } catch {
    return undefined;
  }
}
